export const home = {
  btn_signin: "Sign in",
  btn_signup: "Create an account",
  go_to_dashboard: "Dashboard",
  txt_header_section_1: "Your tool for",
  txt_header_section_2: "Invoicing",
  txt_description:
    "We define the problem, the objective, and create a proposal for the user once we have understood their needs.",
  info_innov_title: "Innovation",
  info_innov_description:
    "We offer advanced technological solutions to simplify your billing process.",

  info_simplicity_title: "Simplicity",
  info_simplicity_description:
    "We are committed to making billing management easy and accessible for everyone.",

  info_transp_title: "Transparency",
  info_transp_description:
    "We ensure complete transparency in your billing processes to avoid any ambiguity.",
  about_us_description:
    "We offer advanced technological solutions to simplify your billing process. We offer advanced technological solutions to simplify your billing process. We offer advanced technological solutions to simplify your billing process. We offer advanced technological solutions to simplify your billing process.",
  about_us_title: "Who are we!",
  service_title: "Our Services",
  service_sub_title: "Features",

  // services

  service_one_title: "Création et gestion de factures ",
  service_one_description:
    "Notre logiciel permet de générer des factures professionnelles en quelques secondes. Grâce à des modèles personnalisables, vous pouvez adapter chaque facture à l'identité de votre entreprise. Les informations récurrentes sont automatiquement pré-remplies, vous offrant un gain de temps considérable.",

  service_one_title: "Création et gestion de factures",
  service_one_description:
    "Notre logiciel permet de générer des factures professionnelles en quelques secondes. Grâce à des modèles personnalisables, vous pouvez adapter chaque facture à l'identité de votre entreprise. Les informations récurrentes sont automatiquement pré-remplies, vous offrant un gain de temps considérable.",

  service_two_title: "Suivi des paiements en temps réel",
  service_two_description:
    "Gardez un œil sur tous vos paiements et évitez les retards grâce à un suivi en temps réel. Recevez des alertes lorsque des paiements sont dus et gérez vos relances directement depuis l'interface, pour ne jamais manquer une opportunité.",

  service_three_title: "Gestion de devis et proformas",
  service_three_description:
    "Éditez, envoyez et suivez vos devis et proformas facilement. Transformez-les ensuite en factures lorsque vous êtes prêt à finaliser une transaction. Cela vous permet de rester organisé et de gérer vos ventes de manière fluide.",

  service_four_title: "Rapports financiers détaillés et personnalisables",
  service_four_description:
    "Accédez à des rapports financiers clairs et détaillés pour analyser vos revenus, vos dépenses et la rentabilité de votre entreprise. Personnalisez les rapports selon vos besoins pour avoir une vue d'ensemble précise de votre santé financière.",

  service_five_title: "Conformité fiscale et mise à jour automatique",
  service_five_description:
    "Restez en conformité avec la législation fiscale grâce à des mises à jour automatiques qui garantissent que vos factures respectent toujours les dernières normes en vigueur. Notre solution vous évite toute erreur et simplifie vos démarches fiscales.",

  service_six_title: "Facturation multi-devises et multilingue",
  service_six_description:
    "Pour les entreprises internationales, notre logiciel propose une facturation en plusieurs devises et langues. Vous pouvez facilement gérer vos transactions avec des clients à l'étranger, tout en restant conforme aux exigences locales.",

  service_one_title: "Invoice Creation and Management",
  service_one_description:
    "Our software allows you to generate professional invoices in seconds. With customizable templates, you can tailor each invoice to match your company’s identity. Recurring information is automatically pre-filled, saving you valuable time.",

  service_two_title: "Real-Time Payment Tracking",
  service_two_description:
    "Keep an eye on all your payments and avoid delays with real-time tracking. Receive alerts when payments are due and manage your reminders directly from the interface, so you never miss an opportunity.",

  service_three_title: "Quote and Proforma Management",
  service_three_description:
    "Easily create, send, and track your quotes and proformas. Then convert them into invoices when you're ready to finalize a transaction. This helps you stay organized and manage your sales smoothly.",

  service_four_title: "Detailed and Customizable Financial Reports",
  service_four_description:
    "Access clear, detailed financial reports to analyze your revenue, expenses, and business profitability. Customize the reports to fit your needs and get a precise overview of your financial health.",

  service_five_title: "Tax Compliance and Automatic Updates",
  service_five_description:
    "Stay compliant with tax regulations through automatic updates that ensure your invoices always meet the latest standards. Our solution prevents errors and simplifies your tax processes.",

  service_six_title: "Multi-Currency and Multi-Language Billing",
  service_six_description:
    "For international businesses, our software offers invoicing in multiple currencies and languages. Easily handle transactions with foreign clients while staying compliant with local requirements.",

  service_seven_title: "Personalized Customer Support",
  service_seven_description:
    "Our team of experts is available to help you with any questions or issues. Enjoy responsive customer support ready to guide and assist you in using our software.",
  service_title1: "Simplify your invoicing",
  service_title2: "Start now",
  create_account: "Create an account",

  txt_service_adjec: "Fast and free",

  facture_title: "Transform your invoice management in just a few clicks",
  facture_sub_title:
    "Adopt the all-in-one solution for optimal invoice management.",
  faq_title: "Frequently Asked Questions (FAQ)",

  faq_1_question: "What is an invoicing software?",
  faq_1_res: "What is an invoicing software?",

  faq_2_question: "Can I customize my invoices?",
  faq_2_res: "What is an invoicing software?",

  faq_3_question: "How can I track my payments?",
  faq_3_res: "What is an invoicing software?",

  faq_4_question: "Is the software secure?",
  faq_4_res: "Contact us! We’re here to help you every step of the way.",
  simple_pricing_1: "Simple Pricing for",
  simple_pricing_2: "your Business",
  simple_pricing_desc:
    "We have several powerful plans to showcase your business and get discovered as a creative entrepreneurs. Everything you need.",

  bill_monthly: "Bill Monthly",
  bill_annualy: "Bill Annualy",

  facturation_title: "Simplify your invoicing — start now!",
  facturation_desc:
    "Save time and reduce errors with our intuitive invoicing software. Try it for free and discover a simpler way to manage your finances.",
  facturation_sub_title: "Fast and free",

  footer_description:
    "Save on your current billing and CRM services, our service is completely free.",
  footer_information: "Information",
  footer_support: "Support",
  footer_legal: "Legal",
  footer_resources: "Resources",

  footer_certification: "Certification",
  footer_how_it_works: "How it works?",
  footer_cost: "How much does it cost?",

  footer_help: "Help",
  footer_contact: "Contact",
  footer_blog: "Blog",

  footer_terms: "Terms of use",
  footer_privacy: "Privacy policy",
  footer_legal_notice: "Legal notice",

  footer_e_invoice: "Electronic invoice",
  footer_billing_software: "Billing software",
  footer_make_invoice: "Create an invoice",
};
